import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon, MDBNavbarBrand } from 'mdb-react-ui-kit';
import logo from "../../assets/logo_fsky.png";
import './footer.css'; // Make sure to create a Footer.css file or use inline styles as well

export default function App() {
  return (
    <MDBFooter className='text-center text-lg-start text-muted' style={{ background: "#354169" }}>
      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1' style={{ fontSize:"18px",  marginTop:"23px"}}>
                {/* <MDBNavbarBrand href="#">
                  <img src={logo} alt="Logo" className="me-3" style={{ width: "40px", height: "40px" }} />
                </MDBNavbarBrand> */}
                First Sky Infrastructure
              </h5>
              <p className="text-white-footer1" style={{ textIndent:"10px", textJustify:"inherit"}}>
                Welcome to First Sky Infra, a trusted name in the construction and real estate industry. With 25 years of experience in the field.
              </p>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1' style={{ fontSize:"18px",marginTop:"23px"}}>Links</h5>
              <div className="footer-links-link">
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/constructionpage' className='text-reset'>Home</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/about/civil' className='text-reset'>About us</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/all-service' className='text-reset'>Service</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/all-project' className='text-reset'>Project</a>
                </p>
              </div>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className='mx-auto mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1' style={{ fontSize:"18px",marginTop:"23px"}}>Links</h5>
              <div className="footer-links-link">
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/ourteam' className='text-reset'>Our Team</a>
                </p>
                
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/real-estate' className='text-reset'>Real Estate</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/gallery' className='text-reset'>Gallery</a>
                </p>
                <p><i className="fa fa-angle-double-right"></i> &nbsp;
                  <a href='/contact' className='text-reset'>Contact us</a>
                </p>
              </div>
            </MDBCol>

            <MDBCol md="3" lg="3" xl="3" className='mx-auto  mb-4'>
              <h5 className='text-uppercase fw-bold mb-4 text-white-footer1'style={{ fontSize:"18px",marginTop:"23px"}} >Contact</h5>
              <p className="text-white-footer1">
                {/* <MDBIcon icon="home" className="me-2" /> */}
               No:21, Vinayaga nagar, Okkiyam Thoraipakkam, Chennai-97
                
              </p>
              <p className="text-white-footer1">
                {/* <MDBIcon icon="envelope" className="me-3" /> */}
                firstskyinfrastructure@gmail.com
              </p>
              <p className="text-white-footer1">
                {/* <MDBIcon icon="phone" className="me-3" /> */}
                +91 9500167678
              </p>
              <p className="text-white-footer1  ">
                {/* <MDBIcon icon="print" className="me-3" /> */}
                 044-48570414
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-2 text-white-footer1' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', borderTop:"1px solid white" }}>
        © 2025 Copyright:
        <a className='text-reset fw-bold' href='https://www.firstskyinfra.in/' target='_blank'>
         First Sky Infrastructure
        </a>
      </div>
    </MDBFooter>
  );
}
